import { EventRegisterReasonEnum } from '../../../core/enums/pod/event_register';

export const getEventRegisterReasonOptions = [
    { value: EventRegisterReasonEnum.NO_INTERNET.value, label: EventRegisterReasonEnum.NO_INTERNET.label },
    { value: EventRegisterReasonEnum.TERMINAL_FAILURE.value, label: EventRegisterReasonEnum.TERMINAL_FAILURE.label },
    { value: EventRegisterReasonEnum.OTHER.value, label: EventRegisterReasonEnum.OTHER.label }
];

export const getEventRegisterReason = (reason) => {
    switch (reason) {
        case EventRegisterReasonEnum.NO_INTERNET.value:
            return EventRegisterReasonEnum.NO_INTERNET.label;
        case EventRegisterReasonEnum.TERMINAL_FAILURE.value:
            return EventRegisterReasonEnum.TERMINAL_FAILURE.label;
        case EventRegisterReasonEnum.OTHER.value:
            return EventRegisterReasonEnum.OTHER.label;
        default:
            return EventRegisterReasonEnum.UNKNOWN.label;
    }
};
